/**
 * Platform-detection helpers.
 *
 * BeeWeddy ships from **one** React codebase to two surfaces:
 *   1. Web (https://beeweddy.com) — full feature set
 *   2. Android APK (Play Store wrap) — restricted feature set
 *
 * Three admin-only features are hidden in the APK to keep Google Play
 * Data-Safety compliance clean (they collect third-party phone numbers
 * via Google Places, which is fine for back-office B2B outreach on web
 * but creates a declarable data-collection surface in the APK):
 *   • Marketing — Vendor / Pro Invites  (AdminMarketingInviteCard)
 *   • Auto WhatsApp Blast                (AdminAutoBlastCard)
 *   • Contact Finder                     (AdminContactFinderCard)
 *
 * Detection priority:
 *   1. `process.env.REACT_APP_PLATFORM === 'app'` — build-time flag the
 *      Capacitor / TWA wrap step sets when generating the APK bundle.
 *   2. `window.Capacitor?.isNativePlatform()` — runtime check that fires
 *      automatically when the JS bundle is loaded inside a Capacitor
 *      WebView (works even if the build flag was forgotten).
 *
 * If either fires, the helper returns true.
 */

export const isNativeApp = () => {
  if (process.env.REACT_APP_PLATFORM === 'app') return true;
  if (typeof window !== 'undefined' && window.Capacitor &&
      typeof window.Capacitor.isNativePlatform === 'function') {
    try { return window.Capacitor.isNativePlatform(); } catch (_) { return false; }
  }
  return false;
};

export const isWebPlatform = () => !isNativeApp();
